import { useEffect, useState } from "react";

//material ui imports
import {
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
  Stack,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";

//third party imports
import * as Yup from "yup";
import { useFormik } from "formik";
import { axiosAuth } from "../../../api";

const CandidateFilterDlg = (props) => {
  //Constants
  const { onSave, onCancel, filterData } = props;
  const theme = useTheme();
  const pageSize = 500;
  //States
  const [loading, setLoading] = useState(false);
  const [candidateSpecialization, setCandidateSpecialization] = useState([]);
  const [selectedSpecialization, setSelectedSpecialization] = useState(null);
  const [selectedSubSpecialization, setSelectedSubSpecialization] =
    useState(null);
  const [subSpecializations, setSubSpecializations] = useState([]);

  const formik = useFormik({
    initialValues: filterData,
    validationSchema: Yup.object({
      name: Yup.string().max(50, "Must be 50 characters or less"),
      phoneNumber: Yup.string().max(10, "Must be 10 digits or less"),
      location: Yup.string().max(50, "Must be 50 characters or less"),
      degreeName: Yup.string().max(50, "Must be 50 characters or less"),
      specialization: Yup.string().max(50, "Must be 50 characters or less"),
      companyName: Yup.string().max(50, "Must be 50 characters or less"),
      position: Yup.string().max(50, "Must be 50 characters or less"),
      currentJobStatus: Yup.number().min(0, "Should be >= 0"),
      minExperience: Yup.number().min(0, "Should be >= 0"),
      maxExperience: Yup.number().min(0, "Should be >= 0"),
      minSalary: Yup.number().min(0, "Should be >= 0"),
      maxSalary: Yup.number().min(0, "Should be >= 0"),
      registrationStatus: Yup.string(),
      skills: Yup.string(),
    }),

    onSubmit: (values) => {
      if (values.minSalary == "") {
        values.minSalary = 0;
      }
      if (values.maxSalary == "") {
        values.maxSalary = 0;
      }
      values.filterApplied = true;
      onSave(values);
    },
  });

  const getCandidateSpecialization = (skip) => {
    console.log("first");
    axiosAuth
      .get("/api/CandidateSpecializationMasters/list?skip=0&take=" + pageSize)
      .then((response) => {
        setCandidateSpecialization(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSubSpecializations = (specializationId) => {
    axiosAuth
      .get(
        "/api/CandidateSubSpecizalizationMaster/by-candidate-specialization?candidateSpecializationId=" +
          specializationId,
      )
      .then((response) => {
        setSubSpecializations(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCandidateSpecialization();
  }, [pageSize]);

  useEffect(() => {
    console.log(formik.values.candidateSpecializationMasterId);
    if (formik.values.candidateSpecializationMasterId) {
      getSubSpecializations(formik.values.candidateSpecializationMasterId);
    }
  }, [formik.values.candidateSpecializationMasterId]);

  return (
    <>
      <Grid container>
        <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
          <FilterListIcon />

          <Typography
            color={theme.palette.primary.dark}
            variant="h6"
            textAlign="center"
            sx={{ marginLeft: 2 }}
          >
            Candidate Filters
          </Typography>
        </Stack>
      </Grid>
      <Divider sx={{ marginY: 2 }} />
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="name"
              label="Name"
              onChange={formik.handleChange}
              value={formik.values.name}
              fullWidth
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="phoneNumber"
              label="Phone Number"
              onChange={formik.handleChange}
              value={formik.values.naphoneNumberme}
              fullWidth
              error={
                formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
              }
              helperText={
                formik.touched.phoneNumber && formik.errors.phoneNumber
              }
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="location"
              label="Location"
              onChange={formik.handleChange}
              value={formik.values.location}
              placeholder="Search by city, district or taluka"
              fullWidth
              error={formik.touched.location && Boolean(formik.errors.location)}
              helperText={formik.touched.location && formik.errors.location}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="gender-select-label">Gender</InputLabel>
              <Select
                labelId="gender-select-label"
                id="gender-select"
                label="Fender"
                name="gender"
                value={formik.values.gender}
                onChange={formik.handleChange}
              >
                <MenuItem key={0} value={null}>
                  NA
                </MenuItem>
                <MenuItem key={1} value="Male">
                  Male
                </MenuItem>
                <MenuItem key={2} value="Female">
                  Female
                </MenuItem>
                <MenuItem key={3} value="Other">
                  Other
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Divider />
          </Grid>

          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <TextField
              name="degreeName"
              label="Qualification"
              onChange={formik.handleChange}
              value={formik.values.degreeName}
              fullWidth
              error={
                formik.touched.degreeName && Boolean(formik.errors.degreeName)
              }
              helperText={formik.touched.degreeName && formik.errors.degreeName}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl sx={{ marginBottom: 3 }} fullWidth>
              <InputLabel>Specialization</InputLabel>
              <Select
                name="candidateSpecializationMasterId"
                label="Specialization"
                onChange={(e) => {
                  const selected = candidateSpecialization.find(
                    (spec) => spec.id === e.target.value,
                  );
                  formik.setFieldValue(
                    "candidateSpecializationMasterId",
                    e.target.value,
                  );
                  formik.setFieldValue("specialization", selected?.name || "");
                  setSelectedSpecialization(selected?.name || null);
                }}
                value={formik.values.candidateSpecializationMasterId}
              >
                {candidateSpecialization.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl sx={{ marginBottom: 3 }} fullWidth>
              <InputLabel>Sub Specialization</InputLabel>
              <Select
                name="candidateSubSpecializationMasterId"
                label="Sub Specialization"
                onChange={(e) => {
                  const selected = subSpecializations.find(
                    (spec) => spec.id === e.target.value,
                  );
                  formik.setFieldValue(
                    "candidateSubSpecializationMasterId",
                    e.target.value,
                  );
                  formik.setFieldValue(
                    "subSpecialization",
                    selected?.name || "",
                  );
                  setSelectedSubSpecialization(selected?.name || null);
                }}
                value={formik.values.candidateSubSpecializationMasterId}
              >
                {subSpecializations.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="companyName"
              label="Company Name"
              onChange={formik.handleChange}
              value={formik.values.companyName}
              fullWidth
              error={
                formik.touched.companyName && Boolean(formik.errors.companyName)
              }
              helperText={
                formik.touched.companyName && formik.errors.companyName
              }
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="position"
              label="Current Position"
              onChange={formik.handleChange}
              value={formik.values.position}
              fullWidth
              error={formik.touched.position && Boolean(formik.errors.position)}
              helperText={formik.touched.position && formik.errors.position}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="job-status-select-label">
                Current Job Status
              </InputLabel>
              <Select
                labelId="job-status-select-label"
                id="job-status-select"
                label="Current Job Status"
                name="currentJobStatus"
                value={formik.values.currentJobStatus}
                onChange={formik.handleChange}
              >
                <MenuItem key={1} value={1}>
                  Working
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Not Working
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="experience-select-label">Experience</InputLabel>
              <Select
                labelId="experience-select-label"
                id="experience-select"
                label="Experience"
                name="jobExperience"
                value={formik.values.jobExperience}
                onChange={formik.handleChange}
              >
                <MenuItem key={1} value={1}>
                  Fresher
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Experienced
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="registration-select-label">
                Registration Status
              </InputLabel>
              <Select
                labelId="registration-select-label"
                id="registration-select"
                label="Registration Status"
                name="registrationStatus"
                value={formik.values.registrationStatus}
                onChange={formik.handleChange}
              >
                <MenuItem key={1} value={1}>
                  Registered
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Unregistered
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="skills"
              label="Skills"
              onChange={formik.handleChange}
              value={formik.values.skills}
              fullWidth
              error={formik.touched.skills && Boolean(formik.errors.skills)}
              helperText={formik.touched.skills && formik.errors.skills}
            />
          </Grid>
          {formik.values.jobExperience == 2 && (
            <>
              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <TextField
                  name="minExperience"
                  type="number"
                  label="Min Experience (Yrs)"
                  onChange={(e) =>
                    formik.setFieldValue(
                      "minExperience",
                      e.target.value.replace(/^0+(?!$)/, ""),
                    )
                  }
                  value={formik.values.minExperience}
                  fullWidth
                  error={
                    formik.touched.minExperience &&
                    Boolean(formik.errors.minExperience)
                  }
                  helperText={
                    formik.touched.minExperience && formik.errors.minExperience
                  }
                />
                <Typography variant="caption">set 0 to ignore</Typography>
              </Grid>
              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <TextField
                  name="maxExperience"
                  type="number"
                  label="Max Experience (Yrs)"
                  placeholder="set 0 to ignore"
                  onChange={(e) =>
                    formik.setFieldValue(
                      "maxExperience",
                      e.target.value.replace(/^0+(?!$)/, ""),
                    )
                  }
                  value={formik.values.maxExperience}
                  fullWidth
                  error={
                    formik.touched.maxExperience &&
                    Boolean(formik.errors.maxExperience)
                  }
                  helperText={
                    formik.touched.maxExperience && formik.errors.maxExperience
                  }
                />
                <Typography variant="caption">set 0 to ignore</Typography>
              </Grid>
            </>
          )}
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="minSalary"
              label="Min Monthly Salary"
              type="number"
              onChange={(e) =>
                formik.setFieldValue(
                  "minSalary",
                  e.target.value.replace(/^0+(?!$)/, ""),
                )
              }
              value={formik.values.minSalary}
              fullWidth
              error={
                formik.touched.minSalary && Boolean(formik.errors.minSalary)
              }
              helperText={formik.touched.minSalary && formik.errors.minSalary}
            />
            <Typography variant="caption">set 0 to ignore</Typography>
          </Grid>

          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="maxSalary"
              label="Max Monthly Salary"
              type="number"
              onChange={(e) =>
                formik.setFieldValue(
                  "maxSalary",
                  e.target.value.replace(/^0+(?!$)/, ""),
                )
              }
              value={formik.values.maxSalary}
              fullWidth
              error={
                formik.touched.maxSalary && Boolean(formik.errors.maxSalary)
              }
              helperText={formik.touched.maxSalary && formik.errors.maxSalary}
            />
            <Typography variant="caption">set 0 to ignore</Typography>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel>Availability</InputLabel>
              <Select
                name="isCandidateAvailable"
                label="Availability"
                value={formik.values.isCandidateAvailable}
                onChange={(e) =>
                  formik.setFieldValue("isCandidateAvailable", e.target.value)
                }
              >
                <MenuItem value={0}>All</MenuItem>
                <MenuItem value={1}>Available</MenuItem>
                <MenuItem value={2}>Unavailable</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}></Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isDeleted"
                    checked={formik.values.isDeleted}
                    onChange={formik.handleChange}
                  />
                }
                label="Show Only Deleted Candidates"
              />
            </FormGroup>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="amountDue"
                    checked={formik.values.amountDue}
                    onChange={formik.handleChange}
                  />
                }
                label="Show Candidates with Payment Due"
              />
            </FormGroup>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="createDateFrom"
              label="Registration Date From"
              type="date"
              onChange={formik.handleChange}
              value={formik.values.createDateFrom ?? ""}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <TextField
              name="createDateTo"
              label="Registration Date To"
              type="date"
              onChange={formik.handleChange}
              value={formik.values.createDateTo ?? ""}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Divider />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
            <Grid>
              <Button variant="contained" type="submit">
                Apply
              </Button>
              <Button
                variant="outlined"
                onClick={onCancel}
                sx={{ marginLeft: 2 }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default CandidateFilterDlg;
